<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title">Contact Us!</h1>
      <h2 class="subtitle">You can get in touch with us through the various options below:</h2>
      <div class="columns is-centered">
        <div class="column is-narrow">
          <div class="contact-div level">
            <a class="level-left contact-link" href="mailto:info@genexinstitute.com">
              <span class="level-item icon is-medium">
                <svg aria-hidden="true" focusable="false">
                  <use xlink:href="../assets/img/icons/icons.svg#envelope"></use>
                </svg>
              </span>
              <p class="level-item">info@genexinstitute.com</p>
            </a>
          </div>

          <!-- <div class="contact-div level">
            <a class="level-left contact-link">
              <span class="level-item">
                <font-awesome-icon class="whatsapp-icon" :icon="['fab', 'whatsapp']"/>
              </span>
              <p class="level-item">+27 (0)71 121 5257</p>
            </a>
          </div> -->
          <div class="contact-div level">
            <a
              class="level-left contact-link"
              href="https://www.facebook.com/GenEx-666146207159010/?modal=admin_todo_tour"
              target="_blank"
            >
              <span class="level-item icon is-medium">
                <svg aria-hidden="true" focusable="false">
                  <use xlink:href="../assets/img/icons/icons.svg#facebook"></use>
                </svg>
              </span>
              <p class="level-item">facebook</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Contact",
  data: function() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variables", "../assets/scss/partials/contact";
</style>

